<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="alumno/reporte" titulo="Reporte / Alumno" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large "
        style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
        <span>Cargando...</span>
    </span>


</div>

<div id="banner" align="center" *ngIf="buscando">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large "
        style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
        <span>Buscando...</span>
    </span>


</div>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; height:100%;">

            <!-- formulario -->
            <section class="hero is-primary">
                <div class="hero-body">
                    <a id="catalogos"
                        (click)="ctrl.tipos_regimenes_fiscales = []; ctrl.grupos = []; ctrl.cargarCatalogo('periodos_escolares_vigentes', 'periodo-escolar-vigente'); ctrl.cargarCatalogo('catalogo_incidencias', 'catalogo-incidencia'); ctrl.cargarCatalogo('tipos_bajas', 'tipo-baja'); ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan'); ctrl.cargarCatalogo('paises', 'paises');  ctrl.cargarCatalogo('articulos', 'servicio'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64'); ctrl.cargarCatalogo('estadosA','estados'); ctrl.cargarCatalogo('municipiosA', 'municipios');"></a>
                    <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
                    <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>
                    <!-- Opciones  -->
                    <section class="hero is-primary">
                        <div class="hero-head">
                            <nav class="level">
                                <!-- Left side -->
                                <div class="level-left">
                                    <div class="level-item">
                                        <p class="title">
                                            <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                                <i class="icon-insurance"></i>
                                            </span>
                                            <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                                                <i class="icon-election fa-spin"></i>
                                            </span>

                                            <span class="icon is-medium">
                                                <i class="icon-file"></i>
                                            </span> Expediente de Alumno
                                        </p>
                                    </div>

                                </div>

                                <!-- Right side -->
                                <div class="level-right">

                                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                                        <span class="icon fa-2x">
                                            <i class="icon-back"> </i>
                                        </span>
                                        <span class="tooltiptext">Regresar</span>
                                    </a>

                                    <a class="navbar-item is-primary tooltip" (click)="cargarDatos(alumnos.id)"
                                        id='cargar_datos_actualizar' *ngIf="alumnos.id != ''">
                                        <span class="icon fa-2x">
                                            <i class="icon-worldwide"></i>
                                        </span>
                                        <span class="tooltiptext">Actualizar</span>
                                    </a>

                                </div>
                            </nav>
                        </div>
                    </section>
                </div>
            </section>

            <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <nav class="level ">
                            <!-- Left side -->
                            <div class="level-left ">
                                <div class="level-item">
                                    <p class="title">
                                        <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                            <i class="icon-edit-1"></i>
                                        </span> Buscar alumno
                                    </p>
                                </div>
                            </div>
                            <div class="level-right " style=" width: 78%; ">
                                <div class="level-item" style=" width: 100%; ">
                                    <!-- <div class="field has-addons">
                                        <p class="control has-icons-left is-expanded">
                                          <input class="input is-medium is-success" type="text" placeholder="Find a post" />
                                        </p>
                                        <p class="control">
                                          <button class="button">Search</button>
                                        </p>
                                      </div> -->
                                    <div class="control has-icons-left is-expanded" style="width: 100%;">
                                        <input class="input is-success is-medium" type="text"
                                            placeholder="Escribe el nombre del alumno, o la matrícula"
                                            [(ngModel)]="busqueda" (keydown.enter)="buscar($event.target.value)">
                                        <!--    <input autofocus autocomplete="off" ngui-auto-complete
                                            [source]="observableSource.bind(this)" [tab-to-select]="false"
                                            [list-formatter]="autocompleListFormatter" [close-on-focusout]="true"
                                            id='buscarArticulo' value-property-name="id" display-property-name="id"
                                            path-to-data="" loading-text="Cargando..."
                                            no-match-found-text="No hay resultados."
                                            (valueChanged)="select_articulo_autocomplete($event)" min-chars="3"
                                            class="input is-success is-medium" type="text"
                                            placeholder="Escribe el nombre del alumno, o la matrícula">
                                        <span class="icon is-medium is-left">
                                            <i class="icon-search3"></i>
                                        </span>-->

                                    </div>
                                    <div class="control has-icons-left is-expanded">
                                        <button class="button is-medium is-light is-success" (click)="buscar(busqueda)">
                                            <span> <i class="icon-search3"></i></span></button>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="cargando || cargarDatosCatalogo">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>

                <!-- <div class="is-fullwidth has-text-centered" *ngIf="buscando">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Buscando...</span>
                    </span>
                </div> -->
                <!--  -->
                <section>
                    <div class="tile" *ngIf="resultados!=''">
                        <div class="tile is-parent">
                            <article class=" tile is-child notification">
                                <div class="media-content">
                                    <div class="content">
                                        <div class="card" style="overflow:auto; height: 52vh;">
                                            <header class="card-header">
                                                <h3 class="card-header-title">Resultados</h3>
                                            </header>
                                            <div class="card-content">

                                                <table class="table is-narrow is-hoverable is-fullwidth">
                                                    <thead>

                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let alumno of resultados">
                                                            <div class="card shadow-lg"
                                                                style="margin: 1.5rem; border-radius: 5px;">
                                                                <div class="card-content"
                                                                    (click)="select_articulo_autocomplete(alumno)">

                                                                    <div class="content">
                                                                        <h5>
                                                                            {{alumno.nombre}}
                                                                            {{alumno.apellido_paterno}}
                                                                            {{alumno.apellido_materno}}
                                                                        </h5>
                                                                        <span class="tag is-dark is-medium">CURP:
                                                                            {{alumno.curp}}</span> &nbsp;
                                                                        <span
                                                                            class="tag is-dark is-medium">{{alumno.carreras.nombre}}</span>
                                                                        &nbsp;
                                                                        <span class="tag is-dark is-medium"
                                                                            *ngIf="alumno.matricula !='' && alumno.matricula != null">Matricula:
                                                                            {{alumno.matricula}}</span>
                                                                        <span class="tag is-dark is-medium"
                                                                            *ngIf="alumno.matricula ==''|| alumno.matricula == null">Matricula:
                                                                            s/m</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <!-- <div class="content">
                                                  Lorem ipsum leo risus, porta ac consectetur ac, vestibulum at eros. Donec
                                                  id elit non mi porta gravida at eget metus. Cum sociis natoque penatibus
                                                  et magnis dis parturient montes, nascetur ridiculus mus. Cras mattis
                                                  consectetur purus sit amet fermentum.
                                                </div> -->
                                            </div>
                                        </div>
                                        <!-- <p>
                                            <strong>John Smith</strong> <small>@johnsmith</small>
                                            <small>31m</small>
                                            <br />
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                                            efficitur sit amet massa fringilla egestas. Nullam condimentum luctus
                                            turpis.
                                          </p> -->
                                    </div>
                                </div>
                                <!--  <div class="content">
                                    <div class="card" *ngFor="let alumno of resultados">
                                        <div class="card-content">
                                            <h4>
                                                {{alumno.nombre}} {{alumno.apellido_materno}} {{alumno.apellido_paterno}}
                                            </h4>
                                        </div>
                                    </div>
                                </div> -->
                            </article>
                        </div>
                    </div>
                    <div class="tile" *ngIf="alumnos.alumnos_metadatos.nombre != ''">
                        <div class="tile is-parent">
                            <article class=" tile is-child notification">

                                <div class="content">
                                    <div class="card">
                                        <div class="card-content">

                                            <div class="media">
                                                <div class="media-left">
                                                    <figure class="image is-96x96">
                                                        <img [src]="alumnos.alumnos_metadatos.foto != null ? ctrl.API_PATH+'/adjunto/alumnos/'+alumnos.alumnos_metadatos.foto : './assets/128x128.png'"
                                                            alt="Image">
                                                    </figure>
                                                </div>

                                                <div class="media-content level">

                                                    <div class=" level-item has-text-centered">
                                                        <div>
                                                            <p class="heading">NOMBRE</p>
                                                            <p class="title">{{alumnos.nombre}}
                                                                {{alumnos.apellido_paterno}}
                                                                {{alumnos.apellido_materno}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="level-item has-text-centered">
                                                        <div>
                                                            <p class="heading">MATRICULA</p>
                                                            <p class="title">{{alumnos.matricula}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="level-item has-text-centered">
                                                        <div>
                                                            <p class="heading">GRUPO</p>
                                                            <p class="title">{{alumnos.grupos.clave}} -
                                                                {{alumnos.grupos.nivel}}
                                                                {{alumnos.grupos.identificador}}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="media">
                                                <div class="media-left">
                                                    <P>ESTATUS: <span class="tag"
                                                            [ngClass]="estatus_alumno.color">{{estatus_alumno.etiqueta}}</span>
                                                    </P>

                                                    <P *ngIf="alumnos.becas != null">BECA:

                                                        <b *ngIf="alumnos.becas.becas != null">
                                                            {{ alumnos.becas.becas.nombre}}
                                                        </b>


                                                        <b *ngIf="alumnos.becas.becas == null">
                                                            Sin beca
                                                        </b>


                                                    </P>

                                                    <P *ngIf="alumnos.becas == null">BECA:
                                                        <b> Sin Beca</b>

                                                    </P>
                                                    <!-- <P>BECA: <b>{{alumnos.becas ? alumnos.becas.becas.nombre : 'Sin
                                                            beca'}}</b></P>  -->
                                                    <P>EMAIL:
                                                        <b>{{alumnos.email}}</b>
                                                    </P>

                                                </div>

                                                <div class="media-content level">

                                                    <div class="level-item has-text-centered">
                                                        <div>
                                                            <p class="heading">CARRRERA </p>
                                                            <p class="title">{{alumnos.carreras.nombre}}</p>
                                                        </div>
                                                    </div>

                                                    <div class=" level-item has-text-centered">
                                                        <div>
                                                            <p class="heading">PLAN DE ESTUDIOS</p>
                                                            <p class="title">{{alumnos.carrera_plan.nombre}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="level-item has-text-centered">
                                                        <div>
                                                            <p class="heading">MODALIDAD</p>
                                                            <p class="title">{{alumnos.modalidades.nombre}}</p>
                                                        </div>
                                                    </div>




                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <!--  <div class="box">
                                     <article class="media">
                                            <div class="media-left">
                                                <figure class="image is-64x64">
                                                    <img [src]="alumnos.alumnos_metadatos.foto != null ? ctrl.API_PATH+'/adjunto/alumnos/'+alumnos.alumnos_metadatos.foto : './assets/128x128.png'"
                                                        alt="Image">
                                                </figure>
                                            </div>
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>
                                                            {{alumnos.alumnos_metadatos.nombre }}
                                                            {{alumnos.alumnos_metadatos.apellido_paterno }}
                                                            {{alumnos.alumnos_metadatos.apellido_materno }}
                                                        </strong>
                                                        <small>{{alumnos.alumnos_metadatos.email}}</small>
                                                        <span> Grupo: {{alumnos.grupos.clave}}</span>
                                                        <span> Nivel: {{alumnos.grupos.nivel}}
                                                            {{alumnos.grupos.identificador}}</span>
                                                        <span> Beca: {{alumnos.becas ? alumnos.becas.becas.nombre : 'Sin
                                                            beca'}}</span>
                                                        <br>
                                                        <strong> Carrera Plan:</strong> {{alumnos.carrera_plan.nombre}}
                                                        <strong> Carrera:</strong> {{alumnos.carreras.nombre}}
                                                        <br>
                                                        <strong> Modalidad:</strong> {{alumnos.modalidades.nombre}}
                    
                                                        <span class="tag"
                                                            [ngClass]="estatus_alumno.color">{{estatus_alumno.etiqueta}}</span>
                    
                                                    </p>
                    
                                                </div>
                                            </div>
                                        </article>
                                    </div> -->

                                    <!--   <div class="columns" style="margin-top: 20px;"
                                        ngIf="permisos.indexOf('AlumnoOperacionController.reporte') > -1 ">
                                        <div class="column is-4" style="padding: 0px;" *ngIf="kardex.length > 0">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporte'); imprimirKardex();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-exam"></i>
                                                </span>
                                                <span>Historial acádemico</span>
                                            </button>
                                        </div> -->

                                    <!-- <div class="column is-4" style="padding: 0px;" >
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporte'); imprimirFinanza();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-money4"></i>
                                                </span>
                                                <span>Historial financiero</span>
                                            </button>
                                        </div> -->

                                    <!--  <div class="column is-4" style="padding: 0px;">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporteKardex');verKardex();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-file2"></i>
                                                </span>
                                                <span>Kardex</span>
                                            </button>
                                        </div> -->
                                    <!-- 
                                        <div class="column is-4" style="padding: 0px;"
                                            ngIf="lista_incidencias.length > 0">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporte'); imprimirIncidencia();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-insurance"></i>
                                                </span>
                                                <span>Historial de incidencia</span>
                                            </button>
                                        </div> 
                    
                                    </div>-->

                                    <!-- <div class="columns" style="margin-top: 20px;"
                                        ngIf="permisos.indexOf('AlumnoOperacionController.reporte') > -1 && (kardex.length > 0 || finanza.data.length > 0 || lista_incidencias.length > 0)">
                                        <div class="column is-4" style="padding: 0px;" *ngIf="kardex.length > 0">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporte'); imprimirKardex();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-exam"></i>
                                                </span>
                                                <span>Historial acádemico</span>
                                            </button>
                                        </div>
                    
                                        <div class="column is-4" style="padding: 0px;" *ngIf="finanza.data.length > 0">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporte'); imprimirFinanza();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-money4"></i>
                                                </span>
                                                <span>Historial financiero</span>
                                            </button>
                                        </div>
                    
                                        <div class="column is-4" style="padding: 0px;">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporteKardex');verKardex();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-file2"></i>
                                                </span>
                                                <span>Kardex</span>
                                            </button>
                                        </div>
                    
                                        <div class="column is-4" style="padding: 0px;"
                                            *ngIf="lista_incidencias.length > 0">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporte'); imprimirIncidencia();"
                                                style="height: 100px;">
                                                <span class="icon is-small is-right">
                                                    <i class="icon-insurance"></i>
                                                </span>
                                                <span>Historial de incidencia</span>
                                            </button>
                                        </div>
                    
                                    </div> -->

                                    <div class="columns" style="margin-top: 20px;">
                                        <div class="column is-6" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.reporteFinanciero') > -1">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporteFinanciero');verFinanciero();"
                                                style="height: 100px;">
                                                <span class="icon fa-2x has-text-info">
                                                    <i class="icon-money4"></i>
                                                </span>
                                                <span>Historial Financiero</span>
                                            </button>
                                        </div>

                                        <div class="column is-6" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.reporteKardexD') > -1">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reporteKardex');verKardex();"
                                                style="height: 100px;">
                                                <span class="icon fa-2x has-text-info">
                                                    <i class="icon-file2"></i>
                                                </span>
                                                <span>Historial Académico</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="columns" style="margin-top: 20px;">

                                        <div class="column" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.actualizarDatosPersonales') > -1">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('datos_personales');" style="height: 100px;">
                                                <span class="icon fa-2x has-text-info">
                                                    <i class="icon-document-1"></i>
                                                </span>
                                                <span>Datos personales</span>
                                            </button>
                                        </div>

                                        <div class="column " style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.rfcs') > -1 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('rfcs');" style="height: 100px;">
                                                <span class="icon fa-2x has-text-default">
                                                    <i class="icon-credit-card-2"></i>
                                                </span>
                                                <span>Datos fiscales</span>
                                            </button>
                                        </div>

                                        <div class="column" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.cupones') > -1 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('cupones');" style="height: 100px;">
                                                <span class="icon fa-2x has-text-info">
                                                    <i class="icon-document-1"></i>
                                                </span>
                                                <span>Descuentos autorizados</span>
                                            </button>
                                        </div>



                                        <div class="column " style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.pausa') > -1 ">
                                            <button class="button is-fullwidth is-fullheight"
                                                [disabled]="estatus_alumno.estado == 'pausa_academica' || estatus_alumno.estado == 'baja'"
                                                type="button" (click)="ctrl.abrirModal('pausa');"
                                                style="height: 100px;">
                                                <span class="icon fa-2x has-text-default">
                                                    <i class="icon-credit-card-2"></i>
                                                </span>
                                                <span>Pausa academica</span>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- <div class="columns" style="margin-top: 20px;" *ngIf="(alumnos.alumnos_inicializacion && alumnos.alumnos_inicializacion.inicializado==1 && permisos.indexOf('AlumnoOperacionController.desinicializar') > -1 ) || (permisos.indexOf('AlumnoOperacionController.inicializacion') > -1 && alumnos.alumnos_inicializacion &&
                    alumnos.alumnos_inicializacion.inicializado==0)"> -->
                                    <div class="columns" style="margin-top: 20px;" *ngIf="(alumnos.alumnos_inicializacion && alumnos.alumnos_inicializacion.inicializado==1 || alumnos.alumnos_inicializacion &&
                    alumnos.alumnos_inicializacion.inicializado==0)">
                                        <div class="column is-3" style="padding: 0px;"
                                            *ngIf="alumnos.alumnos_inicializacion && alumnos.alumnos_inicializacion.inicializado==1 && permisos.indexOf('AlumnoOperacionController.desinicializar') > -1 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('desinicializacion');" style="height: 100px;">
                                                <span class="icon fa-2x has-text-danger">
                                                    <i class="icon-swap"></i>
                                                </span>
                                                <span>Desincorporación <br>académico-financiera</span>
                                            </button>
                                        </div>

                                        <div class="column is-3" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.inicializacion') > -1 && alumnos.alumnos_inicializacion && alumnos.alumnos_inicializacion.inicializado==0 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('inicializacion');" style="height: 100px;">
                                                <span class="icon fa-2x has-text-warning">
                                                    <i class="icon-clock2"></i>
                                                </span>
                                                <span>Incorporación <br>académico-financiera</span>
                                            </button>
                                        </div>

                                        <div class="column is-3" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.quitar_beca') > -1 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('quitar_beca');" style="height: 100px;"
                                                [disabled]="alumnos.becas_id == null">
                                                <span class="icon fa-2x has-text-warning">
                                                    <i class="icon-donation-4"></i>
                                                </span>
                                                <span>Quitar beca</span>
                                            </button>
                                        </div>

                                        <div class="column is-3" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.materiasDuplicadas') > -1 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('materias_duplicadas');"
                                                style="height: 100px;">
                                                <span class="icon fa-2x has-text-error">
                                                    <i class="icon-blinder"></i>
                                                </span>
                                                <span>Eliminar<br> materias duplicadas</span>
                                            </button>
                                        </div>

                                        <div class="column is-3" style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.reincorporacion') > -1 ">
                                            <button class="button is-fullwidth is-fullheight" type="button"
                                                (click)="ctrl.abrirModal('reincorporacion');" style="height: 100px;">
                                                <span class="icon fa-2x has-text-success">
                                                    <i class="icon-candidate"></i>
                                                </span>
                                                <span>Reincorporación</span>
                                            </button>
                                        </div>

                                    </div>

                                    <div class="columns" style="margin-top: 20px;"
                                        *ngIf="permisos.indexOf('AlumnoOperacionController.baja') > -1 ">
                                        <div class="column"
                                            [ngClass]="personas_historial_bajas.length > 0 ? 'is-4' : 'is-6'"
                                            style="padding: 0px;" *ngIf="!alumnos.baja">
                                            <button class="button is-fullwidth is-fullheight is-danger" type="button"
                                                (click)="ctrl.abrirModal('baja');" style="height: 100px;">
                                                <span class="icon fa-2x">
                                                    <i class="icon-man"></i>
                                                </span>
                                                <span class="icon fa-2x">
                                                    <i class="icon-trash"></i>
                                                </span>
                                                <span>&nbsp; Baja a alumno</span>
                                            </button>
                                        </div>

                                        <div class="column"
                                            [ngClass]="personas_historial_bajas.length > 0 ? 'is-4' : 'is-6'"
                                            style="padding: 0px;" *ngIf="alumnos.baja">
                                            <button class="button is-fullwidth is-fullheight is-danger" type="button"
                                                (click)="ctrl.abrirModal('confirmarEliminar4');" style="height: 100px;">
                                                <span class="icon fa-2x">
                                                    <i class="icon-man"></i>
                                                </span>
                                                <span class="icon fa-2x">
                                                    <i class="icon-trash"></i>
                                                </span>
                                                <span>&nbsp; Deshacer baja alumno</span>
                                            </button>
                                        </div>

                                        <div class="column "
                                            [ngClass]="personas_historial_bajas.length > 0 ? 'is-4' : 'is-6'"
                                            style="padding: 0px;" *ngIf="personas_historial_bajas.length > 0">
                                            <button class="button is-fullwidth is-fullheight is-warning" type="button"
                                                (click)="ctrl.abrirModal('historialBaja');" style="height: 100px;">
                                                <span class="icon fa-2x">
                                                    <i class="icon-man"></i>
                                                </span>
                                                <span class="icon fa-2x">
                                                    <i class="icon-list-12 "></i>
                                                </span>
                                                <span>&nbsp; Historial de bajas</span>
                                            </button>
                                        </div>

                                        <div class="column"
                                            [ngClass]="personas_historial_bajas.length > 0 ? 'is-4' : 'is-6'"
                                            style="padding: 0px;"
                                            *ngIf="permisos.indexOf('AlumnoOperacionController.incidencia') > -1">
                                            <button class="button is-fullwidth is-fullheight is-link" type="button"
                                                (click)="ctrl.abrirModal('incidencia');" style="height: 100px;">
                                                <span class="icon fa-2x">
                                                    <i class="icon-man"></i>
                                                </span>
                                                <span class="icon fa-2x">
                                                    <i class="icon-hold  "></i>
                                                </span>
                                                <span>&nbsp; Incidencia</span>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </article>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</div>


<div [formGroup]="data">

    <div class="modal" id="reincorporacion">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-list-12"></i>
                    </span> Reincorporación v1
                </p>
                <button type="button" class="delete" (click)="cancelarModal('reincorporacion')"></button>
            </header>
            <section class="modal-card-body">
                <div class="tabs is-boxed">
                    <ul>
                        <li [ngClass]="{ 'is-active' : tab == 1}">
                            <a (click)="tab=1">
                                <span class="icon ">
                                    <i class="fa fa-file"></i>
                                </span>
                                <span>Agregar Reincorporación</span>
                            </a>
                        </li>

                        <li [ngClass]="{ 'is-active' : tab == 2}">
                            <a (click)="tab=2">
                                <span class="icon ">
                                    <i class="fa fa-list"></i>
                                </span>
                                <span>Lista de reincorporaciones</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div [ngClass]="{ 'is-hidden': tab != 1}">

                    <span formArrayName="inscripciones_grupos_siguientes"
                        *ngIf="data.controls.inscripciones_grupos_siguientes">
                        <nav class="panel"
                            *ngFor="let igs of data.controls.inscripciones_grupos_siguientes.controls; let i=index"
                            [formGroupName]="i">
                            <p class="panel-heading">
                                Reincorporación # {{ i + 1 }}

                                <button style="margin-top: -5px; float:right" type="button" class="button is-danger"
                                    (click)="ctrl.quitar_form_array(data.controls.inscripciones_grupos_siguientes, i)">
                                    <i class="icon-trash"></i>
                                </button>
                            </p>
                            <div class="panel-block">
                                <div style="width:100%">
                                    <div class="columns">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Periodo Escolar: {{igs.personas_id}}</label>
                                                <div class="control has-icons-left has-icons-right">
                                                    <div class="select"
                                                        [ngClass]="{'is-danger': igs.get('periodos_escolares_id').hasError('required')}">
                                                        <a id="cargar_grupos"
                                                            (click)="ctrl.grupos = []; ctrl.cargarCatalogo('grupos', 'grupo-reincorporacion?periodos_escolares_id='+periodos_escolares_seleccionado+'&personas_id='+this.data.controls.id.value);"></a>
                                                        <ng-select2
                                                            [disabled]="ctrl.periodos_escolares_vigentes ? (ctrl.periodos_escolares_vigentes.length == 0 ? true : false) : true"
                                                            name="periodos_escolares_id"
                                                            formControlName="periodos_escolares_id"
                                                            [options]="ctrl.optionSelect"
                                                            [data]="ctrl.periodos_escolares_vigentes"
                                                            (valueChanged)="cargarGrupos($event)">
                                                        </ng-select2>

                                                    </div>
                                                    <span class="icon is-small is-right"
                                                        *ngIf="igs.get('periodos_escolares_id').hasError('required')">
                                                        <i class="fa fa-warning"></i>
                                                    </span>
                                                    <span class="help is-danger"
                                                        *ngIf="igs.get('periodos_escolares_id').hasError('required')">Este
                                                        campo es requerido.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <!--<label class="label">Grupo</label>
        <div class="control has-icons-left has-icons-right">
            <div class="select">
                <select class="select" formControlName="grupos_id">
                                                            <option value="">Seleccione</option>
                                                            <option *ngFor="let item of grupos" value="{{item.id}}">{{item.nombre}}</option>
                                                        </select>
            </div>
            <span class="icon is-small is-right" *ngIf="igs.get('grupos_id').hasError('required') ">
                                                        <i class="fa fa-warning"></i>
                                                    </span>
            <span class="help is-danger" *ngIf="igs.get('grupos_id').hasError('required') ">Este campo es requerido.</span>
        </div>-->
                                            <label class="label has-text-warning">Grupo Origen</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <!-- <a id="detalleGrupo" (click)="detalleGrupo(ctrl.dato.get('grupos_id').value);"></a> -->
                                                <div class="select">
                                                    <ng-select2 name="grupos_id" formControlName="grupos_id"
                                                        [disabled]="ctrl.grupos ? (ctrl.grupos.length == 0 ? true : false) : true"
                                                        [options]="ctrl.optionSelect"
                                                        [value]="igs.controls.grupos_id.value" [data]="ctrl.grupos">
                                                    </ng-select2>
                                                </div>
                                                <span class="icon is-small is-right"
                                                    *ngIf="igs.get('grupos_id').hasError('required') ">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                                <span class="help is-danger"
                                                    *ngIf="igs.get('grupos_id').hasError('required') ">Este campo es
                                                    requerido.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </span>
                </div>

                <div [ngClass]="{ 'is-hidden': tab != 2}">  
                    <table class="table is-striped is-fullwidth" style="width:100% !important;">
                        <thead>
                            <tr>
                                <th><abbr>[ ID ]</abbr></th>
                                <th>GRUPO</th>
                                <th>INCORPORADO</th>
                                <th>ACTUALIZACIÓN</th>
                                <!-- <th>IMPORTE</th>
                <th>UTILIZADO</th> -->
                                <th>ACCIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let val of lista_inscripciones_grupos_siguientes; let i = index;">
                                <td style="vertical-align: middle;">{{ i + 1 }}</td>
                                <td style="vertical-align: middle;">{{ val.grupos.clave ? val.grupos.clave + ' ' +
                                    val.grupos.nivel + ' ' + val.grupos.identificador : ' ' }}</td>
                                <td style="vertical-align: middle;">
                                    <span *ngIf="val.inscripciones_id==NULL"> NO </span>
                                    <span *ngIf="val.inscripciones_id!=NULL"> SI </span>
                                </td>
                                <td style="vertical-align: middle;">{{ val.updated_at }}</td>
                                <td>
                                    <button class="navbar-item  is-danger tooltip" type="button"
                                        [ngClass]="{'is-loading': cargando}" *ngIf="val.inscripciones_id==NULL"
                                        (click)="eliminar(val.id, 'reincorporacion')">
                                        <span class="icon fa-2x has-text-danger">
                                            <i class="icon-trash"></i>
                                        </span>
                                        <span class="tooltiptext">Eliminar</span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer class="modal-card-foot" *ngIf="data.controls.inscripciones_grupos_siguientes">
                <button type="button" class="button is-default"
                    (click)="tab=1; ctrl.agregar_form_array(data.controls.inscripciones_grupos_siguientes, form_inscripciones_grupos_siguientes)">
                    <i class="icon-add2"></i>
                    <span>&nbsp; Agregar Reincorporación</span>
                </button>
                <button type="button" class="button is-success"
                    (click)="guardar(data.controls.id.value,'reincorporacion')"
                    [disabled]="data.controls.inscripciones_grupos_siguientes.controls.length == 0">
                    <i class="icon-diskette "></i>
                    <span>&nbsp;Guardar Reincorporación</span>
                </button>
                <button type="button" class="button" (click)="cancelarModal('reincorporacion')">
                    <i class="icon-close"></i>
                    <span>&nbsp;Cancelar</span>
                </button>
            </footer>
        </div>
    </div>

    <div class="modal" id="materias_duplicadas">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <i class="fa fa-warning"></i> Confirmación
                </p>
                <button class="delete" (click)="ctrl.cancelarModal('materias_duplicadas')"></button>
            </header>
            <section class="modal-card-body">
                <div class="content">
                    <h1>¿Esta seguro de iniciar el proceso de eliminar duplicados?</h1>
                    <p>Este proceso puede tardar unos minutos</p>
                </div>
            </section>
            <footer class="modal-card-foot">
                <a class="button is-success"
                    (click)="guardar(data.controls.id.value,'materias_duplicadas')">Continuar</a>
                <a class="button" (click)="cancelarModal('materias_duplicadas')">Cancelar</a>
            </footer>
        </div>
    </div>

    <div class="modal" id="desinicializacion">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <i class="fa fa-warning"></i> Confirmación
                </p>
                <button class="delete" (click)="ctrl.cancelarModal('desinicializacion')"></button>
            </header>
            <section class="modal-card-body">
                <div class="content">
                    <h1>¿Esta seguro de cancelar la incorporación académico-financiera?</h1>
                    <p>Al aceptar: se eliminan pagos de tipo colegiatura e inscripciones y permitirá la incorporación
                        académico-financiera nuevamente</p>
                </div>
            </section>
            <footer class="modal-card-foot">
                <a class="button is-success" (click)="guardar(data.controls.id.value,'desinicializacion')">Continuar</a>
                <a class="button" (click)="cancelarModal('desinicializacion')">Cancelar</a>
            </footer>
        </div>
    </div>

    <div class="modal" id="quitar_beca">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <i class="fa fa-warning"></i> Confirmación
                </p>
                <button class="delete" (click)="ctrl.cancelarModal('quitar_beca')"></button>
            </header>
            <section class="modal-card-body">
                <div class="content">
                    <h1>¿Esta seguro de quitar la beca para este alumno?</h1>
                    <p>Ya no se podra deshacer esta acción</p>
                </div>
            </section>
            <footer class="modal-card-foot">
                <a class="button is-success" (click)="guardar(data.controls.id.value,'quitar-beca')">Continuar</a>
                <a class="button" (click)="cancelarModal('quitar_beca')">Cancelar</a>
            </footer>
        </div>
    </div>

    <div class="modal" id="inicializacion">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-list-12"></i>
                    </span> Incorporación académico-financiera
                </p>
                <button type="button" class="delete" (click)="cancelarModal('inicializacion')"></button>
            </header>
            <section class="modal-card-body">
                <div>
                    <div class="columns">
                        <div class="column">
                            Seleccione una de las opciones del combo "Última colegiatura pagada". El sistema utilizará
                            estos datos como referencia para el proceso de cobranza de colegiaturas
                        </div>
                    </div>
                    <div class="columns" formGroupName="alumnos_inicializacion">
                        <div class="column is-4">
                            <label class="label">Última colegiatura abonada incompleta</label>
                            <div class="control has-icons-left has-icons-right">
                                <div class="select">
                                    <select class="select" name="mes"
                                        [ngClass]="{'is-danger': data.controls.alumnos_inicializacion.get('mes').hasError('required') }"
                                        formControlName="mes">
                                        <option value="0">Seleccione</option>
                                        <option value="{{item}}" *ngFor="let item of mensualidades">{{item}}a</option>
                                    </select>
                                </div>
                            </div>
                            <span class="icon is-small is-right"
                                *ngIf="data.controls.alumnos_inicializacion.get('mes').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger"
                                *ngIf="data.controls.alumnos_inicializacion.get('mes').hasError('required')">Este campo
                                es
                                requerido.</span>
                        </div>
                        <!-- <div class="column is-6">
                <label class="label">Seleccione una de las opciones del combo "Última colegiatura pagada". El sistema utilizará estos datos como
                    referencia para el proceso de cobranza de colegiaturas </label>
                </div> -->

                        <div class="column is-4">
                            <div class="b-checkbox is-info">
                                <input id="completado" class="styled"
                                    [checked]="data.controls.alumnos_inicializacion.get('completado').value == '1' ? true : false"
                                    (change)="data.controls.alumnos_inicializacion.get('completado').patchValue(data.controls.alumnos_inicializacion.get('completado').value == '1' ? '0' : '1')"
                                    type="checkbox">
                                <label for="completado">
                                    Última colegiatura abonada incompleta
                                </label>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="field"
                                *ngIf="data.controls.alumnos_inicializacion.get('completado').value == 1">
                                <label class="label">Cantidad Abonada:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="number" placeholder="Cantidad abonada"
                                        formControlName="ultimo_abono">

                                    <!-- <span class="help is-danger" *ngIf="!data.controls.alumnos_inicializacion.get('ultimo_abono').hasError('required')">Este campo es requerido.</span> -->
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <a class="button is-success" (click)="guardar(data.controls.id.value,'inicializacion')">Guardar</a>
                <a class="button" (click)="cancelarModal('inicializacion')">Cancelar</a>
            </footer>
        </div>
    </div>


    <div class="modal" id="datos_personales" [formGroup]="datos_personalesF">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-trash"></i>
                    </span> Datos Personales
                </p>
                <button type="button" class="delete" (click)="cancelarModal('datos_personales')"></button>
            </header>
            <section class="modal-card-body">

                <span>
                    <div class="columns">
                        <div class="column">
                            <p class="title" style="font-size:large;">Datos del Alumno</p>
                        </div>
                        <div class="column">
                            <label class="checkbox">
                                <input type="checkbox" formControlName="reset_contrasenia"
                                    style="transform: scale(1.5); margin-right: 0.5em;">
                                Resetear Contraseña
                            </label>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Nombre:</label>
                                <input class="input" type="text" placeholder="Nombre" formControlName="nombre"
                                    [ngClass]="{'is-danger': datos_personalesF.get('nombre').hasError('required') }" />
                                <span class="icon is-small is-right"
                                    *ngIf="datos_personalesF.get('nombre').hasError('required')">
                                    <i class="fa fa-warning"></i></span>
                                <span class="help is-danger"
                                    *ngIf="datos_personalesF.get('nombre').hasError('required')">Este
                                    campo es requerido.</span>
                            </div>
                        </div>

                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Apellido paterno:</label>
                                <input class="input" type="text" placeholder="Apellido paterno"
                                    formControlName="apellido_paterno"
                                    [ngClass]="{'is-danger': datos_personalesF.get('apellido_paterno').hasError('required') }">
                                <span class="icon is-small is-right"
                                    *ngIf="datos_personalesF.get('apellido_paterno').hasError('required')">
                                    <i class="fa fa-warning"></i></span>
                                <span class="help is-danger"
                                    *ngIf="datos_personalesF.get('apellido_paterno').hasError('required')">Este
                                    campo es requerido.</span>
                            </div>
                        </div>

                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Apellido materno:</label>
                                <input class="input" type="text" placeholder="Apellido materno"
                                    formControlName="apellido_materno"
                                    [ngClass]="{'is-danger': datos_personalesF.get('apellido_materno').hasError('required') }">
                                <span class="icon is-small is-right"
                                    *ngIf="datos_personalesF.get('apellido_materno').hasError('required')">
                                    <i class="fa fa-warning"></i></span>
                                <span class="help is-danger"
                                    *ngIf="datos_personalesF.get('apellido_materno').hasError('required')">Este
                                    campo es requerido.</span>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Curp:</label>
                                <input class="input" type="text" placeholder="Curp" formControlName="curp">
                                <!-- <span class="icon is-small is-right"
                                        *ngIf="data.get('datos_personales').get('nombre').hasError('required')">
                                        <i class="fa fa-warning"></i></span>
                                    <span class="help is-danger"
                                        *ngIf="data.get('datos_personales').get('nombre').hasError('required')">Este
                                        campo es requerido.</span> -->
                            </div>
                        </div>

                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Fecha de nacimiento:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" formControlName="fecha_nacimiento" type="date">
                                    <!-- <span class="icon is-small is-right"
                                            *ngIf="data.get('personas_historial_bajas').get('fecha_baja').hasError('required')">
                                            <i class="fa fa-warning"></i></span>
                                        <span class="help is-danger"
                                            *ngIf="data.get('personas_historial_bajas').get('fecha_baja').hasError('required')">Este
                                            campo es requerido.</span> -->
                                </p>
                            </div>
                        </div>

                        <div class="column is-4">
                            <label class="label">Sexo:</label><br>
                            <div class="field">

                                <div class="b-checkbox is-info is-circular">
                                    <input id="sexo_f" name="sexo" value="F" class="styled" type="radio"
                                        formControlName="sexo">
                                    <label for="sexo_f">
                                        Femenino
                                    </label>

                                    <input id="sexo_m" name="sexo" value="M" class="styled" type="radio"
                                        formControlName="sexo">
                                    <label for="sexo_m">
                                        Masculino
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>

                    <hr>
                    <p class="title" style="font-size:large;">Datos de Contacto</p>
                    <div class="columns">
                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Email:</label>
                                <div class="control is-expanded  has-icon has-icon-left">
                                    <input class="input" type="text" placeholder="Email" formControlName="email"
                                        [ngClass]="{'is-danger': datos_personalesF.get('email').hasError('required') }">
                                    <span class="icon is-small is-right"
                                        *ngIf="datos_personalesF.get('email').hasError('required') ">
                                        <i class="fa fa-warning"></i> Campo requerido
                                    </span>

                                </div>
                            </div>
                        </div>

                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Teléfono:</label>
                                <div class="control is-expanded  has-icon has-icon-left">
                                    <input class="input" type="text" placeholder="Teléfono" maxlength="10"
                                        formControlName="telefono">
                                </div>
                            </div>
                        </div>

                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Teléfono:</label>
                                <div class="control is-expanded  has-icon has-icon-left">
                                    <input class="input" type="text" placeholder="Teléfono" maxlength="10"
                                        formControlName="telefono2">
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>
                    <p class="title" style="font-size:large;">Domicilio del alumno</p>
                    <div formGroupName="datos_adicionales">
                        <div class="columns">
                            <div class="column is-4">
                                <label class="label">Estado:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select"
                                            (change)="ctrl.catalogoDependiente('municipios', 'municipiosA',datos_personalesF.get('datos_adicionales').get('domicilio_estado').value)"
                                            formControlName="domicilio_estado">
                                            <option value="0">Seleccione</option>
                                            <option *ngFor="let item of ctrl.estadosA;" value="{{item.id}}">
                                                {{item.nombre}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="column is-4">
                                <label class="label">Municipio</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="domicilio_municipio">
                                            <option value="0">Seleccione</option>
                                            <option *ngFor="let item of ctrl.municipiosA;" value="{{item.id}}">
                                                {{item.nombre}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">Colonia</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="domicilio_colonia" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-8">
                                <div class="field">
                                    <label class="label">Calle</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="domicilio_calle" type="text">
                                    </p>
                                </div>
                            </div>

                            <div class="column is-2">
                                <div class="field">
                                    <label class="label">N° Ext.</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="domicilio_exterior" type="text">
                                    </p>
                                </div>
                            </div>

                            <div class="column is-2">
                                <div class="field">
                                    <label class="label">N° Int.</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="domicilio_interior" type="number">
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-12">
                                <div class="field">
                                    <label class="label">Referencias del domicilio</label>
                                    <div class="control">
                                        <textarea formControlName="domicilio_referencias"
                                            class="textarea has-fixed-size"
                                            placeholder="Referencias del domicilio"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <hr>
                    <p class="title" style="font-size:large;">Datos Tutores</p>
                    <div formGroupName="datos_tutores">
                        <div class="columns is-desktop">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Nombre</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="nombre" type="text">
                                    </p>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Parentesco</label>
                                    <div class="control has-icons-left has-icons-right">
                                        <div class="select">
                                            <select class="select" formControlName="parentesco">
                                                <option value="0">Seleccione</option>
                                                <option *ngFor="let item of parentescos;" value="{{item.id}}">
                                                    {{item.descripcion}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns is-desktop">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Teléfono</label>
                                    <div class="control">
                                        <input class="input" type="text" placeholder="telefono" maxlength="10"
                                            formControlName="telefono">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Correo eléctronico</label>
                                    <div class="control">
                                        <input class="input" type="text" placeholder="ejemplo@dominio.com"
                                            formControlName="email">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>


                        <div class="columns is-desktop">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Nombre</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="nombre2" type="text">
                                    </p>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Parentesco</label>
                                    <div class="control has-icons-left has-icons-right">
                                        <div class="select">
                                            <select class="select" formControlName="parentesco2">
                                                <option value="0">Seleccione</option>
                                                <option *ngFor="let item of parentescos;" value="{{item.id}}">
                                                    {{item.descripcion}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns is-desktop">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Teléfono</label>
                                    <div class="control">
                                        <input class="input" type="text" placeholder="telefono" maxlength="10"
                                            formControlName="telefono2">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Correo eléctronico</label>
                                    <div class="control">
                                        <input class="input" type="text" placeholder="ejemplo@dominio.com"
                                            formControlName="email2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>
                    <p class="title" style="font-size:large;">Datos de Contacto</p>
                    <div formGroupName="datos_adicionales">
                        <div class="columns is-desktop">
                            <div class="column is-4">
                                <label class="label">Tipo de sangre</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="tipo_sangre">
                                            <option value="0">Seleccione</option>
                                            <option *ngFor="let tipo of tipos_de_sangre ;" value="{{tipo.id}}">
                                                {{tipo.descripcion}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="column is-4">
                                <label class="label">Factor Rh</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="factor_rh">
                                            <option value="0">Seleccione</option>
                                            <option *ngFor="let factor of factor_rh ;" value="{{factor.id}}">
                                                {{factor.descripcion}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">Alergias</label>
                                    <div class="control has-icons-left has-icons-right">
                                        <input id="si" name="presenta_alergias" value="1" class="styled"
                                            style="transform: scale(1.5); margin-right: 0.5em;" type="radio"
                                            formControlName="presenta_alergias">
                                        <label for="si">
                                            Sí
                                        </label>

                                        <input id="no" name="presenta_alergias" value="2" class="styled"
                                            style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                                            type="radio" formControlName="presenta_alergias">
                                        <label for="no">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns is-desktop"
                            *ngIf="datos_personalesF.get('datos_adicionales').get('presenta_alergias').value == '1'">
                            <div class="column is-12">
                                <div class="field">
                                    <label class="label">Cuales son</label>
                                    <div class="control">
                                        <textarea formControlName="alergias" class="textarea has-fixed-size" rows="1"
                                            placeholder="Alergias"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns is-desktop">
                            <div class="column is-12">
                                <div class="field">
                                    <label class="label">Padecimientos</label>
                                    <div class="control">
                                        <textarea formControlName="padecimientos" class="textarea has-fixed-size"
                                            rows="2" placeholder="Padecimientos"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns is-desktop">
                            <div class="column is-12">
                                <div class="field">
                                    <label class="label">Contacto médico</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="contacto_medico" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns is-desktop">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Teléfono</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="telefono_medico" maxlength="10"
                                            type="text">
                                    </p>
                                </div>
                            </div>

                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Télefono 2</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" formControlName="telefono_medico2" maxlength="10"
                                            type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>

            </section>
            <footer class="modal-card-foot">

                <button type="button" class="button is-success" (click)="ctrl.abrirModal('confirmarActualizacion')">
                    <i class="icon-diskette "></i>
                    <span>&nbsp;Guardar</span>
                </button>
                <button type="button" class="button" (click)="cancelarModal('datos_personales')">
                    <i class="icon-close"></i>
                    <span>&nbsp;Cancelar</span>
                </button>
            </footer>
        </div>
    </div>

    <div class="modal" id="cupones">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-list-12"></i>
                    </span> Descuentos autorizados
                </p>
                <button type="button" class="delete" (click)="cancelarModal('cupones')"></button>
            </header>
            <section class="modal-card-body">
                <div class="tabs is-boxed">
                    <ul>
                        <li [ngClass]="{ 'is-active' : tab == 1}">
                            <a (click)="tab=1">
                                <span class="icon ">
                                    <i class="fa fa-file"></i>
                                </span>
                                <span>Agregar nuevo cupon</span>
                            </a>
                        </li>

                        <li [ngClass]="{ 'is-active' : tab == 2}">
                            <a (click)="tab=2">
                                <span class="icon ">
                                    <i class="fa fa-list"></i>
                                </span>
                                <span>Lista de cupones</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div [ngClass]="{ 'is-hidden': tab != 1}">

                    <span formArrayName="personas_cupones" *ngIf="data.controls.personas_cupones">
                        <nav class="panel" *ngFor="let cupon of data.controls.personas_cupones.controls; let i=index"
                            [formGroupName]="i">
                            <p class="panel-heading">
                                Decuento # {{ i + 1 }}

                                <button style="margin-top: -5px; float:right" type="button" class="button is-danger"
                                    (click)="ctrl.quitar_form_array(data.controls.personas_cupones, i)">
                                    <i class="icon-trash"></i>
                                </button>
                            </p>
                            <div class="panel-block">
                                <div style="width:100%">
                                    <div class="columns">
                                        <div class="column is-6">
                                            <label class="label">Articulo:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" name="articulos_id"
                                                        [ngClass]="{'is-danger': cupon.get('articulos_id').hasError('required') }"
                                                        formControlName="articulos_id">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.articulos;"
                                                            value="{{item.id}}">{{item.nombre}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Importe:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="importe" type="number"
                                                        [ngClass]="{'is-danger': cupon.get('importe').hasError('required')}" />

                                                    <span class="icon is-small is-right"
                                                        *ngIf="cupon.get('importe').hasError('required') ">
                                                        <i class="fa fa-warning"></i>
                                                    </span>
                                                    <span class="help is-danger"
                                                        *ngIf="cupon.get('importe').hasError('required') ">Este campo es
                                                        requerido.</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Inicio vigencia:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="date" formControlName="inicio_vigencia"
                                                        [ngClass]="{'is-danger': cupon.get('inicio_vigencia').hasError('required')}" />

                                                    <span class="icon is-small is-right"
                                                        *ngIf="cupon.get('inicio_vigencia').hasError('required') ">
                                                        <i class="fa fa-warning"></i>
                                                    </span>
                                                    <span class="help is-danger"
                                                        *ngIf="cupon.get('inicio_vigencia').hasError('required') ">Este
                                                        campo es requerido.</span>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Fin vigencia:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="date" formControlName="fin_vigencia"
                                                        [ngClass]="{'is-danger': cupon.get('fin_vigencia').hasError('required')}" />

                                                    <span class="icon is-small is-right"
                                                        *ngIf="cupon.get('fin_vigencia').hasError('required') ">
                                                        <i class="fa fa-warning"></i>
                                                    </span>
                                                    <span class="help is-danger"
                                                        *ngIf="cupon.get('fin_vigencia').hasError('required') ">Este
                                                        campo es requerido.</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </span>


                </div>

                <div [ngClass]="{ 'is-hidden': tab != 2}">
                    <table class="table is-striped is-fullwidth" style="width:100% !important;">
                        <thead>
                            <tr>
                                <th><abbr>ID</abbr></th>
                                <th>DESCRIPCION</th>
                                <th>FECHA INICIO</th>
                                <th>FECHA FIN</th>
                                <th>IMPORTE</th>
                                <th>UTILIZADO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let val of lista_cupones; let i = index;">
                                <td style="vertical-align: middle;">{{ i + 1 }}</td>
                                <td style="vertical-align: middle;">{{ val.articulos.nombre }}</td>
                                <td style="vertical-align: middle;">{{ val.inicio_vigencia }}</td>
                                <td style="vertical-align: middle;">{{ val.fin_vigencia }}</td>
                                <td style="vertical-align: middle;">
                                    {{ val.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}</td>
                                <td style="vertical-align: middle;"
                                    [style.background]="val.utilizado ? 'indianred' : 'lightgreen'">
                                    {{ val.utilizado ? 'Si' : 'No' }}</td>
                                <td>
                                    <button class="navbar-item  is-danger tooltip" type="button"
                                        [ngClass]="{'is-loading': cargando}" [disabled]="val.utilizado"
                                        (click)="eliminar(val.id, 'cupones')">
                                        <span class="icon fa-2x has-text-danger">
                                            <i class="icon-trash"></i>
                                        </span>
                                        <span class="tooltiptext">Eliminar</span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer class="modal-card-foot" *ngIf="data.controls.personas_cupones">
                <button type="button" class="button is-default"
                    (click)="tab=1; ctrl.agregar_form_array(data.controls.personas_cupones, form_personas_cupones)">
                    <i class="icon-add2"></i>
                    <span>&nbsp; Agregar cupon</span>
                </button>
                <button type="button" class="button is-success" (click)="guardar(data.controls.id.value,'cupones')"
                    [disabled]="data.controls.personas_cupones.controls.length == 0">
                    <i class="icon-diskette "></i>
                    <span>&nbsp;Guardar cupon</span>
                </button>
                <button type="button" class="button" (click)="cancelarModal('cupones')">
                    <i class="icon-close"></i>
                    <span>&nbsp;Cancelar</span>
                </button>
            </footer>
        </div>
    </div>

    <div class="modal" id="rfcs">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-list-12"></i>
                    </span> Datos fiscales
                </p>
                <button type="button" class="delete" (click)="cancelarModal('rfcs')"></button>
            </header>
            <section class="modal-card-body">
                <div>
                    <span formArrayName="personas_rfcs" *ngIf="data.controls.personas_rfcs">
                        <nav class="panel" *ngFor="let rfc of data.controls.personas_rfcs.controls; let i=index"
                            [formGroupName]="i">
                            <p class="panel-heading">
                                RFC # {{ i + 1 }}

                                <button style="margin-top: -5px; float:right" type="button" class="button is-danger"
                                    (click)="ctrl.quitar_form_array(data.controls.personas_rfcs, i)">
                                    <i class="icon-trash"></i>
                                </button>
                            </p>
                            <div class="panel-block">
                                <div style="width:100%">
                                    <div class="columns">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Razón Social:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="Razón Social"
                                                        formControlName="razon_social">

                                                    <span class="help is-danger"
                                                        *ngIf="!data.controls.personas_rfcs.controls[i].controls.razon_social.valid">Este
                                                        campo es
                                                        requerido.</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Rfc:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="Rfc"
                                                        formControlName="rfc">

                                                    <span class="help is-danger"
                                                        *ngIf="!data.controls.personas_rfcs.controls[i].controls.rfc.valid">Este
                                                        campo es
                                                        requerido.</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-6">
                                            <div class="field">
                                                <div class="field">
                                                    <label class="label">Correo eléctronico:</label>
                                                    <p class="control has-icons-left has-icons-right">
                                                        <input class="input" type="text"
                                                            placeholder="Correo eléctronico" formControlName="email">

                                                    </p>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="column is-2">
                                            <br>
                                            <br>
                                            <div class="field">
                                                <div class="b-checkbox is-info is-circular">
                                                    <input id="tipo_persona_f_{{i}}" name="tipo_persona" value="Fisica"
                                                        class="styled" type="radio" formControlName="tipo_persona"
                                                        (click)="ctrl.catalogoDependiente('tipo-regimen-fiscal', 'tipos_regimenes_fiscales', data.controls.personas_rfcs.controls[i].controls.tipo_persona.value, i);">
                                                    <label for="tipo_persona_f_{{i}}">
                                                        Fisica
                                                    </label>

                                                    <input id="tipo_persona_m_{{i}}" name="tipo_persona" value="Moral"
                                                        class="styled" type="radio" formControlName="tipo_persona"
                                                        (click)="ctrl.catalogoDependiente('tipo-regimen-fiscal', 'tipos_regimenes_fiscales', data.controls.personas_rfcs.controls[i].controls.tipo_persona.value, i);">
                                                    <label for="tipo_persona_m_{{i}}">
                                                        Moral
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Tipos regimenes fiscales:</label>
                                            <div class="select">
                                                <select class="select" name="tipos_regimenes_fiscales_id"
                                                    formControlName="tipos_regimenes_fiscales_id">
                                                    <option
                                                        *ngFor="let item of ctrl.tipos_regimenes_fiscales[i] ; let i = index; "
                                                        [value]="item.clave">({{item.clave}}) {{item.nombre}}</option>
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-4">
                                            <label class="label">País:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select"
                                                        (click)="ctrl.catalogoDependiente('estados', 'estados',rfc.get('paises_id').value )"
                                                        name="paises_id"
                                                        [ngClass]="{'is-danger': rfc.get('paises_id').hasError('required') }"
                                                        formControlName="paises_id">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.paises;" value="{{item.id}}">
                                                            {{item.nombre}}</option>

                                                    </select>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Estado:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select"
                                                        (change)="ctrl.catalogoDependiente('municipios','municipios' ,rfc.get('estados_id').value)"
                                                        name="estados_id"
                                                        [ngClass]="{'is-danger': rfc.get('estados_id').hasError('required') }"
                                                        formControlName="estados_id">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.estados;" value="{{item.id}}">
                                                            {{item.nombre}}</option>

                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Municipio:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" name="municipios_id"
                                                        [ngClass]="{'is-danger': rfc.get('municipios_id').hasError('required') }"
                                                        formControlName="municipios_id">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.municipios;"
                                                            value="{{item.id}}">{{item.nombre}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Direccion:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="calle"
                                                        formControlName="calle">
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-3">
                                            <div class="field">
                                                <label class="label">Num. Exterior:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="Num. Exterior"
                                                        formControlName="numero_exterior">
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-3">
                                            <div class="field">
                                                <label class="label">Num. Interior:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="Num. Interior"
                                                        formControlName="numero_interior">
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Localidad:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="Localidad"
                                                        formControlName="localidad">
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Col. / Fracc.:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="Col. / Fracc."
                                                        formControlName="colonia">
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Codigo Postal:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" type="text" placeholder="CP"
                                                        formControlName="codigo_postal">
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="b-checkbox is-info is-circular text-success">
                                            <input id="predeterminado_{{i}}" name="predeterminado" value="1"
                                                [checked]="rfc.value.predeterminado == 1 ? true : false"
                                                (click)="predeterminado(rfc.controls.predeterminado)" class="styled"
                                                type="radio" formControlName="predeterminado">
                                            <label for="predeterminado_{{i}}">
                                                Al marcar la casilla, se emitirán las facturas con los datos que de esta
                                                ficha
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </span>

                </div>
            </section>
            <footer class="modal-card-foot" *ngIf="data.controls.personas_rfcs">

                <button type="button" class="button is-default"
                    (click)="ctrl.agregar_form_array(data.controls.personas_rfcs, form_personas_rfcs); ctrl.tipos_regimenes_fiscales[data.controls.personas_rfcs.controls.length] = []; ">
                    <i class="icon-add2"></i>
                    <span>&nbsp; Agregar nuevo RFC</span>
                </button>
                <button type="button" class="button is-success" (click)="guardar(data.controls.id.value, 'rfcs')"
                    [disabled]="data.controls.personas_rfcs.controls.length == 0">
                    <i class="icon-diskette "></i>
                    <span>&nbsp;Guardar RFC</span>
                </button>
                <button type="button" class="button" (click)="cancelarModal('rfcs')">
                    <i class="icon-close"></i>
                    <span>&nbsp;Cancelar</span>
                </button>
            </footer>
        </div>
    </div>

    <div class="modal" id="baja">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-trash"></i>
                    </span> Baja alumno
                </p>
                <button type="button" class="delete" (click)="cancelarModal('baja')"></button>
            </header>
            <section class="modal-card-body">

                <span formGroupName="personas_historial_bajas">
                    <div class="columns">
                        <div class="column is-6">
                            <label class="label">Tipo de baja:</label>
                            <div class="control has-icons-left has-icons-right">
                                <div class="select">
                                    <select class="select" name="tipos_bajas_id"
                                        [ngClass]="{'is-danger': data.get('personas_historial_bajas').get('tipos_bajas_id').hasError('required') }"
                                        formControlName="tipos_bajas_id">
                                        <option value="0">Seleccione</option>
                                        <option *ngFor="let item of ctrl.tipos_bajas;" value="{{item.id}}">
                                            {{item.nombre}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Fecha de baja:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" formControlName="fecha_baja" type="date"
                                        [ngClass]="{'is-danger': data.get('personas_historial_bajas').get('fecha_baja').hasError('required') }" />
                                    <span class="icon is-small is-right"
                                        *ngIf="data.get('personas_historial_bajas').get('fecha_baja').hasError('required')">
                                        <i class="fa fa-warning"></i></span>
                                    <span class="help is-danger"
                                        *ngIf="data.get('personas_historial_bajas').get('fecha_baja').hasError('required')">Este
                                        campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-12">
                            <div class="field">
                                <label class="label">Observación:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <textarea class="textarea is-fullwidth" rows="5" placeholder="Observación"
                                        formControlName="observaciones"></textarea>

                                </p>
                            </div>
                        </div>
                    </div>

                </span>

            </section>
            <footer class="modal-card-foot">

                <button type="button" class="button is-success" (click)="ctrl.abrirModal('confirmarEliminar3')">
                    <i class="icon-diskette "></i>
                    <span>&nbsp;Baja</span>
                </button>
                <button type="button" class="button" (click)="cancelarModal('baja')">
                    <i class="icon-close"></i>
                    <span>&nbsp;Cancelar</span>
                </button>
            </footer>
        </div>
    </div>

    <div class="modal" id="incidencia">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon">
                        <i class="icon-list-12"></i>
                    </span> Incidencias
                </p>
                <button type="button" class="delete" (click)="cancelarModal('incidencia')"></button>
            </header>
            <section class="modal-card-body">
                <div class="tabs is-boxed">
                    <ul>
                        <li [ngClass]="{ 'is-active' : tab2 == 1}">
                            <a (click)="tab2=1">
                                <span class="icon ">
                                    <i class="fa fa-file"></i>
                                </span>
                                <span>Agregar nueva incidencia</span>
                            </a>
                        </li>

                        <li [ngClass]="{ 'is-active' : tab2 == 2}">
                            <a (click)="tab2=2">
                                <span class="icon ">
                                    <i class="fa fa-list"></i>
                                </span>
                                <span>Lista de incidencias</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div [ngClass]="{ 'is-hidden': tab2 != 1}">

                    <span formArrayName="personas_incidencias" *ngIf="data.controls.personas_incidencias">
                        <nav class="panel"
                            *ngFor="let incidencia of data.controls.personas_incidencias.controls; let i=index"
                            [formGroupName]="i">
                            <p class="panel-heading">
                                Incidencia # {{ i + 1 }}

                                <button style="margin-top: -5px; float:right" type="button" class="button is-danger"
                                    (click)="ctrl.quitar_form_array(data.controls.personas_incidencias, i)">
                                    <i class="icon-trash"></i>
                                </button>
                            </p>
                            <div class="panel-block">
                                <div style="width:100%">

                                    <div class="columns">
                                        <div class="column is-12">
                                            <label class="label">Tipo de incidencia:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" name="tipos_bajas_id"
                                                        [ngClass]="{'is-danger': incidencia.get('catalogo_incidencias_id').hasError('required') }"
                                                        formControlName="catalogo_incidencias_id">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.catalogo_incidencias;"
                                                            value="{{item.id}}">{{item.nombre}} /
                                                            {{item.grado_incidencia}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column is-12">
                                            <div class="field">
                                                <label class="label">Descripción:</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <textarea class="textarea is-fullwidth" rows="5"
                                                        placeholder="Descripción"
                                                        formControlName="descripcion"></textarea>

                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column is-12">
                                            <div class="field">
                                                <label class="label">Evidencia:</label>
                                                <div class="control has-icons-left has-icons-right"
                                                    *ngIf="incidencia.get('imagen_evidencia').value == ''">

                                                    <div class="file has-name">
                                                        <label class="file-label">
                                                            <input type="file" class="file-input"
                                                                (change)="ctrl.seleccionarImagenBase64($event, incidencia.controls.imagen_evidencia, false, 'incidencia')"
                                                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                                            <span class="file-cta">
                                                                <span class="file-icon">
                                                                    <i class="fa fa-upload"></i>
                                                                </span>
                                                                <span class="file-label">
                                                                    Seleccionar archivo
                                                                </span>
                                                            </span>

                                                        </label>
                                                    </div>
                                                </div>
                                                <input foto type="hidden" formControlName="imagen_evidencia">
                                                <button type="button" class="button is-danger"
                                                    (click)="ctrl.borrarImagen($event, incidencia.controls.imagen_evidencia, 'configuracion')"
                                                    *ngIf="incidencia.get('imagen_evidencia').value != ''">
                                                    <span class="icon">
                                                        <i class="fa fa-trash"></i>
                                                    </span>
                                                    &nbsp; Eliminar fondo.
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </nav>
                    </span>

                </div>

                <div [ngClass]="{ 'is-hidden': tab2 != 2}">
                    <table class="table is-striped is-fullwidth" style="width:100% !important;">
                        <thead>
                            <tr>
                                <th><abbr>ID</abbr></th>
                                <th>EVIDENCIA</th>
                                <th>DESCRIPCION</th>
                                <th>FECHA</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let val of lista_incidencias; let i = index;">
                                <td style="vertical-align: middle;">{{ i + 1 }}</td>
                                <td style="vertical-align: middle;">
                                    <figure class="image is-64x64"
                                        (click)="ctrl.abrirModal('reporte'); abrirImagen(val.imagen_evidencia != null ? ctrl.API_PATH+'/adjunto/personas/'+val.imagen_evidencia : './assets/128x128.png', 'contenido');">
                                        <img [src]="val.imagen_evidencia != null ? ctrl.API_PATH+'/adjunto/personas/'+val.imagen_evidencia : './assets/128x128.png'"
                                            alt="Image">
                                    </figure>
                                </td>
                                <td style="vertical-align: middle;">{{ val.descripcion }}</td>
                                <td style="vertical-align: middle;">{{ val.created_at }}</td>
                                <td>
                                    <button class="navbar-item  is-danger tooltip" type="button"
                                        [ngClass]="{'is-loading': cargando}"
                                        [disabled]="permisos.indexOf('AlumnoOperacionController.borraIncidencia') <= 0"
                                        (click)="eliminar(val.id, 'incidencia')">
                                        <span class="icon fa-2x has-text-danger">
                                            <i class="icon-trash"></i>
                                        </span>
                                        <span class="tooltiptext">Eliminar</span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer class="modal-card-foot" *ngIf="data.controls.personas_incidencias">
                <button type="button" class="button is-default"
                    (click)="tab2=1; ctrl.agregar_form_array(data.controls.personas_incidencias, form_personas_incidencias)">
                    <i class="icon-add2"></i>
                    <span>&nbsp; Agregar reporte de incidencia</span>
                </button>
                <button type="button" class="button is-success" (click)="guardar(data.controls.id.value,'incidencia')"
                    [disabled]="data.controls.personas_incidencias.controls.length == 0">
                    <i class="icon-diskette "></i>
                    <span>&nbsp;Guardar reporte de incidencia</span>
                </button>
                <button type="button" class="button" (click)="cancelarModal('incidencia')">
                    <i class="icon-close"></i>
                    <span>&nbsp;Cancelar</span>
                </button>
            </footer>
        </div>
    </div>
</div>

<div class="modal" id="reporte">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 96vw;height: 96vh;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
                    <i class="fa fa-file"></i>
                </span> Reporte
            </p>
            <button type="button" class="delete" (click)="ctrl.cancelarModal('reporte');"></button>
        </header>
        <section class="modal-card-body">

            <div style="width: 100%; height: 100%" id="contenido"></div>

        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="ctrl.cancelarModal('reporte');">Cerrar</a>
        </footer>
    </div>
</div>

<div class="modal" id="reporteKardex">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 96vw;height: 96vh;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
                    <i class="fa fa-file"></i>
                </span> {{informacion.nombre}}
            </p>
            <button type="button" class="delete" (click)="ctrl.cancelarModal('reporteKardex');"></button>
        </header>
        <section class="modal-card-body">


            <div class="card">
                <div class="card-content">

                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-96x96">
                                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                            </figure>
                        </div>

                        <div class="media-content level">

                            <div class=" level-item has-text-centered">
                                <div>
                                    <p class="heading">NOMBRE</p>
                                    <p class="title">{{informacion.nombre}}</p>
                                </div>
                            </div>

                            <div class="level-item has-text-centered">
                                <div>
                                    <p class="heading">MATRICULA</p>
                                    <p class="title">{{informacion.matricula}}</p>
                                </div>
                            </div>

                            <div class="level-item has-text-centered">
                                <div>
                                    <p class="heading">CARRERA</p>
                                    <p class="title">{{informacion.carrera}}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="media">
                        <div class="media-left">
                            <P>CURP: <b>{{informacion.curp}}</b></P>
                            <P *ngIf="informacion.email !== null">EMAIL: <b>{{informacion.email}}</b></P>
                            <P *ngIf="informacion.email === null">EMAIL: <b>****</b></P>
                        </div>

                        <div class="media-content level">

                            <div class=" level-item has-text-centered">
                                <div>
                                    <p class="heading">PLAN DE ESTUDIOS</p>
                                    <p class="title">{{informacion.plan_estudio}}</p>
                                </div>
                            </div>

                            <div class="level-item has-text-centered">
                                <div>
                                    <p class="heading">MODALIDAD</p>
                                    <p class="title">{{informacion.modalidad}}</p>
                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div>

            <div *ngFor="let item of datosKardex">
                <div style=" margin-top: 40px; text-align: center;">
                    <!--  <p>
                        <b>
                            {{informacion.modalidad_etiqueta}}: {{item.nivel}}

                        </b>
                        <button class="button is-link is-rounded" (click)="verParcial(item.nivel); ctrl.abrirModal('parcial')">
                            PARCIAL </button>
                        <button class="button is-info is-rounded" (click)="verParcial(item.nivel); ctrl.abrirModal('boleta')">
                            BOLETA </button>
                    </p> -->

                    <div class="columns">
                        <div class="column">
                            <p>
                                <b>
                                    {{informacion.modalidad_etiqueta}}: {{item.nivel}}

                                </b>
                            </p>
                        </div>
                        <div class="column">
                            <button class="button is-info is-rounded"
                                (click)="verParcial(item.nivel); ctrl.abrirModal('parcial')">
                                BOLETA PARCIAL </button>
                            <button class="button is-link is-rounded"
                                (click)="verParcial(item.nivel); ctrl.abrirModal('boleta')">
                                BOLETA {{informacion.modalidad}}</button>
                        </div>
                    </div>

                </div>

                <div class="table-container">
                    <table class="table is-bordered is-striped" style="width:100% !important; font-size: 13px;">
                        <thead>
                            <tr style="text-align: center;">
                                <th>Clave</th>
                                <th>Creditos</th>
                                <th>Materia</th>
                                <th>Grupo</th>
                                <th>Periodo</th>
                                <th>Promedio</th>
                                <th></th>
                                <th>Opcion de Calificación</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let item2 of item.materias">
                                <td style="text-align:center; width: 25px;">{{item2.clave_materia}}</td>
                                <td style="text-align: center ;width: 25px;;">{{item2.creditos_materia}}</td>
                                <td style="text-align: justify; width: 450px;">{{item2.nombre_materia}}</td>

                                <td style="width: 25px;">
                            <tr *ngFor="let item3 of item2.cursamientos">
                                {{item3.grupo}} <br>
                            </tr>
                            </td>

                            <td style="width: 250px; ">
                                <tr style="text-align: center;" *ngFor="let item3 of item2.cursamientos">
                                    <p>{{item3.periodo_escolar}}</p> <br>
                                </tr>
                            </td>

                            <td style="width: 30px; align-content: center;">
                                <tr *ngFor="let item3 of item2.cursamientos">
                                    <ng-container *ngIf="item3.promedio_alumno_materia === null">
                                        <span>
                                            <b>--</b>
                                        </span>
                                    </ng-container>


                                    <ng-container *ngIf="item3.promedio_alumno_materia !== null">
                                        <span>
                                            <b>{{item3.promedio_alumno_materia.promedio}}</b>
                                        </span>
                                    </ng-container>
                                </tr>
                            </td>

                            <td style="width: 30px; text-align: center ;">
                                <tr *ngFor="let item3 of item2.cursamientos">
                                    <ng-container *ngIf="item3.promedio_alumno_materia === null">
                                        <span>
                                            <i class="fa fa-close" style="color:crimson;"></i>
                                        </span>
                                    </ng-container>

                                    <ng-container *ngIf="item3.promedio_alumno_materia !== null">
                                        <span *ngIf="item3.promedio_alumno_materia.aprobado !== 1">
                                            <i class="fa fa-close" style="color:crimson;"></i>
                                        </span>
                                        <span *ngIf="item3.promedio_alumno_materia.aprobado === 1">
                                            <i class="fa fa-check" style="color:rgb(26, 153, 0);"></i>
                                        </span>
                                    </ng-container>
                                </tr>
                            </td>

                            <td style="width: 150px;  text-align: center ;">
                                <tr *ngFor="let item3 of item2.cursamientos">
                                    <ng-container *ngIf="item3.promedio_alumno_materia === null">
                                        <span>
                                            <b>--</b>
                                        </span>
                                    </ng-container>

                                    <ng-container *ngIf="item3.promedio_alumno_materia !== null">
                                        <span>
                                            {{item3.promedio_alumno_materia.opcion_nombre}}
                                            {{item3.promedio_alumno_materia.opcion_tipo}}
                                        </span>
                                    </ng-container>
                                </tr>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal" id="parcial">
                    <div class="modal-background"></div>
                    <div class="modal-card" style="width: 96vw;height: 96vh;">
                        <header class="modal-card-head">
                            <p class="modal-card-title">
                                <span class="icon">
                                    <i class="fa fa-file"></i>
                                </span> Parcial
                            </p>
                            <button type="button" class="delete" (click)="ctrl.cancelarModal('parcial');"></button>
                        </header>
                        <section class="modal-card-body">
                            <div class="card">
                                <div class="card-content">

                                    <div class="media">
                                        <div class="media-left">
                                            <!--  <figure class="image is-96x96">
                                                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                                            </figure> -->
                                        </div>

                                        <div class="media-content level">

                                            <div class=" level-item has-text-centered">
                                                <div>
                                                    <p class="heading">PARCIAL</p>
                                                    <p class="title"> {{informacion.modalidad_etiqueta}}
                                                        {{datosParciales.nivel}}</p>
                                                </div>
                                            </div>

                                            <div class=" level-item has-text-centered">
                                                <div>
                                                    <p class="heading">PERIODO</p>
                                                    <p class="title">{{datosParciales.periodo_cursado}}</p>
                                                </div>
                                            </div>
                                            <div class=" level-item has-text-centered">
                                                <div>
                                                    <p class="heading">PROMEDIO</p>
                                                    <p class="title">{{datosParciales.promedio_nivel.promedio}}</p>
                                                </div>
                                            </div>

                                        </div>

                                    </div>


                                </div>
                            </div>

                            <div class="table-container" style="margin: 20px;">
                                <table class="table is-bordered" style="width:100% !important; font-size: 15px;">
                                    <thead>
                                        <tr style="text-align: center; padding: 8px;">
                                            <th>N</th>
                                            <th>Materias</th>

                                            <ng-container *ngFor="let item of datoCalificaciones">
                                                <th *ngIf="item.numero_parcial > 0">
                                                    Parcial {{item.numero_parcial}}
                                                </th>
                                            </ng-container>

                                            <!--  <th
                                                *ngFor="let item of [].constructor(informacion.numero_parciales); let i = index">
                                                Parcial {{i + 1}}
                                            </th> -->
                                            <th *ngIf="datosParciales.nivel_tiene_practica != 0">Practica</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of datosParciales.materias; let i=index">
                                            <td style="text-align: center; width: 10px;">{{i + 1}}</td>
                                            <td style="text-align: left; width: 200px;">
                                                {{item.nombre_materia}}
                                                
                                            </td>
                                            <ng-container *ngFor="let c of item.cursamientos; let i = index">
                                                <ng-container *ngIf="i == 0">
                                                    <ng-container *ngFor="let cali of c.calificaciones">
                                                        <ng-container *ngIf="cali.numero_parcial > 0">
                                                            <td *ngIf="cali.calificacion != null"
                                                                style="text-align: center; width: 15px;">
                                                                {{cali.calificacion}}
                                                            </td>

                                                            <td *ngIf="cali.calificacion == null"
                                                                style="text-align: center; width: 15px;">
                                                                N/C
                                                            </td>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>

                                            <ng-container *ngFor="let c of item.cursamientos; let i = index">
                                                <ng-container *ngIf="i == 0">
                                                    <ng-container *ngFor="let cali of c.calificaciones">
                                                        <ng-container *ngIf="cali.numero_parcial == 0">
                                                            <td *ngIf="cali.calificacion != null"
                                                                style="text-align: center; width: 15px;">
                                                                {{cali.calificacion}}
                                                            </td>

                                                            <td *ngIf="cali.calificacion == null"
                                                                style="text-align: center; width: 15px;">
                                                                N/C
                                                            </td>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>


                        <footer class="modal-card-foot">
                            <a class="button is-success" (click)="ctrl.cancelarModal('parcial');">Cerrar</a>
                            <a class="button is-link" (click)="imprimirParcial();"> <span class="icon"> <i
                                        class="fa fa-print"></i></span> <span>Parcial</span> </a>
                        </footer>
                    </div>
                </div>

                <div class="modal" id="boleta">
                    <div class="modal-background"></div>
                    <div class="modal-card" style="width: 96vw;height: 96vh;">
                        <header class="modal-card-head">
                            <p class="modal-card-title">
                                <span class="icon">
                                    <i class="fa fa-file"></i>
                                </span> Boleta
                            </p>
                            <button type="button" class="delete" (click)="ctrl.cancelarModal('boleta');"></button>
                        </header>
                        <section class="modal-card-body">
                            <div class="card">
                                <div class="card-content">

                                    <div class="media">
                                        <div class="media-left">
                                            <!--  <figure class="image is-96x96">
                                                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                                            </figure> -->
                                        </div>

                                        <div class="media-content level">

                                            <div class=" level-item has-text-centered">
                                                <div>
                                                    <p class="heading">BOLETA FINAL</p>
                                                    <p class="title"> {{informacion.modalidad_etiqueta}}
                                                        {{datosParciales.nivel}}</p>
                                                </div>
                                            </div>

                                            <div class=" level-item has-text-centered">
                                                <div>
                                                    <p class="heading">PERIODO</p>
                                                    <p class="title">{{datosParciales.periodo_cursado}}</p>
                                                </div>
                                            </div>

                                            <div class=" level-item has-text-centered">
                                                <div>
                                                    <p class="heading">PROMEDIO</p>
                                                    <p class="title">{{datosParciales.promedio_nivel.promedio}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="table-container" style="margin: 20px;">
                                <table class="table is-bordered" style="width:100% !important; font-size: 15px;">
                                    <thead>
                                        <tr style="text-align: center ; padding: 8px;">
                                            <th>N</th>
                                            <th>Materias</th>
                                            <th>Promedio </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of datosParciales.materias; let i=index">
                                            <td style="text-align: center; width:10px">{{i + 1}}</td>
                                            <td style="text-align: left; width:300px">{{item.nombre_materia}}</td>
                                            <ng-container *ngFor="let c of item.cursamientos; let i = index">
                                                <ng-container *ngIf="i == 0">
                                                    <ng-container *ngIf="c.promedio_alumno_materia != null">
                                                        <td *ngIf="c.promedio_alumno_materia.promedio != null"
                                                            style="text-align:center ; width: 20px;">
                                                            {{c.promedio_alumno_materia.promedio}}
                                                        </td>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                        </section>
                        <footer class="modal-card-foot">
                            <a class="button is-success" (click)="ctrl.cancelarModal('boleta');">Cerrar</a>
                            <a class="button is-link" (click)="imprimirBoleta();"> <span class="icon"> <i
                                        class="fa fa-print"></i></span> <span>Boleta</span> </a>
                        </footer>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="ctrl.cancelarModal('reporteKardex');">Cerrar</a>
            <a class="button is-link" (click)="imprimirKardexdos();"> <span class="icon"> <i
                        class="fa fa-print"></i></span> <span>Kardex</span> </a>
            <a class="button is-warning" (click)="imprimirHistorial();"> <span class="icon"> <i
                        class="fa fa-print"></i></span> <span>Historial Académico</span> </a>
        </footer>
    </div>
</div>

<div class="modal" id="reporteFinanciero">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 96vw;height: 96vh;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
                    <i class="fa fa-file"></i>
                </span> Historial Financiero
            </p>
            <button type="button" class="delete" (click)="ctrl.cancelarModal('reporteFinanciero');"></button>
        </header>
        <section class="modal-card-body">


            <div class="card">
                <div class="card-content">

                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-96x96">
                                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                            </figure>
                        </div>

                        <div class="media-content level">

                            <div class=" level-item has-text-centered">
                                <div>
                                    <p class="heading">NOMBRE</p>
                                    <p class="title">{{alumnos.nombre}}
                                        {{alumnos.apellido_paterno}}
                                        {{alumnos.apellido_materno}}</p>
                                </div>
                            </div>

                            <div class="level-item has-text-centered">
                                <div>
                                    <p class="heading">MATRICULA</p>
                                    <p class="title">{{alumnos.matricula}}</p>
                                </div>
                            </div>

                            <div class="level-item has-text-centered">
                                <div>
                                    <p class="heading">CARRERA</p>
                                    <p class="title">{{alumnos.carreras.nombre}}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="media">
                        <div class="media-left">
                            <P>CURP: <b>{{alumnos.curp}}</b></P>
                            <P>EMAIL: <b>{{alumnos.email ? alumnos.email : '***'}}</b></P>
                        </div>

                        <div class="media-content level">

                            <div class=" level-item has-text-centered">
                                <div>
                                    <p class="heading">PLAN DE ESTUDIOS</p>
                                    <p class="title">{{alumnos.carrera_plan.nombre}}</p>
                                </div>
                            </div>

                            <div class="level-item has-text-centered">
                                <div>
                                    <p class="heading">MODALIDAD</p>
                                    <p class="title">{{alumnos.modalidades.nombre}}</p>
                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <div style="margin-top: 25px;">
                <div class="table-container">
                    <table class="table is-bordered is-striped" style="width:100% !important;">
                        <thead>
                            <tr style="text-align: center;">
                                <th> <b>#</b> </th>
                                <th> <b>Fecha</b> </th>
                                <th> <b>Código de venta</b> </th>
                                <th> <b>Importe</b> </th>
                                <th> <b>Método</b> </th>
                                <th> <b>Comprobante</b> </th>
                                <th> <b>Detalles</b> </th>
                                <th> <b>Opciones</b> </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of datosFinancieros; let i = index">
                                <td style="vertical-align: middle;" class="has-text-centered">{{i + 1}}</td>
    <td style="text-align: center; vertical-align: middle;">{{item.movimientos.fecha}} </td>
     <!--<td style="text-align: center; vertical-align: middle;">{{item.movimientos.fecha | formatoFecha}}</td>-->
                                <td style="text-align: center; vertical-align: middle;">{{item.movimientos.codigo}}</td>
                                <td style="text-align: center; vertical-align: middle;">{{item.importe |
                                    currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                                <td style="text-align: center; vertical-align: middle;">
                                    <p style="font-size: small;">{{item.paga_con |
                                        currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</p> <br>
                                    <span class="tag is-success">{{item.tipos_formas_pagos.nombre}}</span>
                                </td>
                                <td class="has-text-centered" style="vertical-align: middle; width: 25px;">

                                    <nav class="level" style="float:left">
                                        <a class="navbar-item tooltip" (click)="ReimprimirT(item)">
                                            <span class="icon fa-2x  has-text-link">
                                                <i class="icon-file2"></i>
                                            </span>
                                            <span class="tooltiptext">Reimprimir ticket</span>
                                        </a>

                                        <a class="navbar-item tooltip" *ngIf="item.movimientos.facturado != 0">
                                            <span class="icon fa-2x  has-text-danger">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span class="tooltiptext">Reimprimir factura</span>
                                        </a>

                                        <!-- <a class="navbar-item tooltip" *ngIf="item.movimientos.facturado == 0" disabled>
                                            <span class="icon fa-2x  has-text-danger">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span class="tooltiptext">Reimprimir factura</span>
                                        </a> -->
                                    </nav>
                                </td>

                                <!-- <td>
                                    <div class="columns has-text-centered is-gapless" >
                                        <div class="column">
                                            <a class="navbar-item tooltip">
                                                <span class="icon fa-2x  has-text-link">
                                                            <i class="icon-file2"></i>
                                                        </span>
                                                <span class="tooltiptext">Reimprimir ticket</span>
                                            </a>
                                        </div>
                                        <div class="column">2</div>
                                    </div>
                                </td> -->
                                <td class="has-text-centered" style="vertical-align: middle;"> <button
                                        class="button is-warning"
                                        (click)="verMovimiento(item.movimientos_id);ctrl.abrirModal('movimiento')">Ver
                                        Más</button>
                                </td>
                                <!-- 
                                <td class="has-text-centered" style="vertical-align: middle; width: 25px; text-align: center;">
                                   
                                    <a class="navbar-item tooltip" (click)="borrarMovimiento(item)">
                                        <span class="icon fa-2x  has-text-danger">
                                            <i class="icon-trash"></i>
                                        </span>
                                        <span class="tooltiptext">Eliminar</span>
                                    </a>
                               
                            </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="modal" id="movimiento">
                <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">
                            <span class="icon">
                                <i class="fa fa-file"></i>
                            </span> Movimientos
                        </p>
                        <button type="button" class="delete" (click)="ctrl.cancelarModal('movimiento');"></button>
                    </header>
                    <section class="modal-card-body">
                        <div class="card" style="box-shadow: 2px 10px 25px 2px rgba(0,0,0,1); border-radius: 15px;">
                            <div class="card-content">

                                <div class="media">
                                    <div class="media-left">
                                        <!--  <figure class="image is-96x96">
                                            <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                                        </figure> -->
                                    </div>

                                    <div class="media-content level">

                                        <div class=" level-item has-text-centered">
                                            <!-- <div>
                                                <p class="heading">PARCIAL</p>
                                                <p class="title"> {{informacion.modalidad_etiqueta}}
                                                    {{datosParciales.nivel}}</p>
                                            </div> -->
                                        </div>

                                        <div class=" level-item has-text-centered">
                                            <!-- <div>
                                                <p class="heading">PERIODO</p>
                                                <p class="title">{{datosParciales.periodo_cursado}}</p>
                                            </div> -->
                                        </div>
                                        <div class=" level-item has-text-centered">
                                            <!-- <div>
                                                <p class="heading">PROMEDIO</p>
                                                <p class="title">{{datosParciales.promedio_nivel.promedio}}</p>
                                            </div> -->
                                        </div>

                                    </div>

                                </div>


                                <div class="table-container">
                                    <table class="table is-bordered is-striped" style="width:100% !important;">
                                        <thead>
                                            <tr style="text-align: center;">
                                                <th> <b>#</b> </th>
                                                <th> <b>Nombre</b> </th>
                                                <th> <b>Fecha de vencimiento</b> </th>
                                                <th> <b>Importe</b> </th>

                                                <!--   <th> <b>Método</b> </th>
                                                <th> <b>Comprobante</b> </th>
                                                <th> <b>Movimientos</b> </th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of datosMovimientos; let i = index">
                                                <td style="vertical-align: middle;" class="has-text-centered">{{i + 1}}
                                                </td>

                                                <td style="text-align: center; vertical-align: middle;"
                                                    *ngIf="item.colegiaturas != null"> Colegiatura
                                                    {{item.colegiaturas.periodos_escolares_colegiaturas.numero_mensualidad}}
                                                </td>


                                                <td style="text-align: center; vertical-align: middle;"
                                                    *ngIf="item.inscripciones !=  null"> Inscripción
                                                </td>

                                                <td style="text-align: center; vertical-align: middle;"
                                                    *ngIf="item.colegiaturas != null">
                                                    {{item.colegiaturas.periodos_escolares_colegiaturas.fecha_pago}}
                                                </td>

                                                <td style="text-align: center; vertical-align: middle;"
                                                    *ngIf="item.inscripciones !=  null">
                                                    {{item.inscripciones.periodos_escolares_colegiaturas.fecha_pago}}
                                                </td>

                                                <td style="text-align: center; vertical-align: middle;"> {{item.importe
                                                    | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                </td>


                                                <!--    <td style="vertical-align: middle;" class="has-text-centered">{{i + 1}}</td>
                                               <td style="text-align: center; vertical-align: middle;"> Colegiatura</td>
                                               <td style="text-align: center; vertical-align: middle;"> {{item.importe}} </td>
                                                <td style="text-align: center; vertical-align: middle;">{{item.movimientos.codigo}}</td>
                                                <td style="text-align: center; vertical-align: middle;">{{item.importe |
                                                    currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <p style="font-size: small;">{{item.paga_con |
                                                        currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</p> <br>
                                                    <span class="tag is-success">{{item.tipos_formas_pagos.nombre}}</span>
                                                </td>
                                                <td class="has-text-centered" style="vertical-align: middle; width: 25px;">
                                                   
                                                        <nav class="level" style="float:left">
                                                            <a class="navbar-item tooltip">
                                                                <span class="icon fa-2x  has-text-link">
                                                                            <i class="icon-file2"></i>
                                                                        </span>
                                                                <span class="tooltiptext">Reimprimir ticket</span>
                                                            </a>
                                                            
                                                            <a class="navbar-item tooltip" >
                                                                <span class="icon fa-2x  has-text-danger">
                                                                            <i class="icon-file"></i>
                                                                        </span>
                                                                <span class="tooltiptext">Reimprimir factura</span>
                                                            </a>
                                                        </nav>
                                                </td>
                
                                               
                                                <td class="has-text-centered" style="vertical-align: middle;"> <button class="button is-primary"  (click)="verMovimiento(item.movimientos_id);ctrl.abrirModal('movimiento')">Ver Más</button>
                                                </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </section>


                    <footer class="modal-card-foot">
                        <a class="button is-success" (click)="ctrl.cancelarModal('movimiento');">Cerrar</a>
                        <!-- <a class="button is-link" (click)="imprimirParcial();"> <span class="icon"> <i
                                    class="fa fa-print"></i></span> <span>Parcial</span> </a> -->
                    </footer>
                </div>
            </div>


            <!-- <div *ngFor="let item of datosKardex">
                <div class="table-container">
                    <table class="table is-bordered is-striped" style="width:100% !important; font-size: 13px;">
                        <thead>
                            <tr style="text-align: center;">
                                <th>Clave</th>
                                <th>Creditos</th>
                                <th>Materia</th>
                                <th>Grupo</th>
                                <th>Periodo</th>
                                <th>Promedio</th>
                                <th></th>
                                <th>Opcion de Calificación</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let item2 of item.materias">
                                <td style="text-align:center; width: 25px;">{{item2.clave_materia}}</td>
                                <td style="text-align: center ;width: 25px;;">{{item2.creditos_materia}}</td>
                                <td style="text-align: justify; width: 450px;">{{item2.nombre_materia}}</td>

                                <td style="width: 25px;">
                            <tr *ngFor="let item3 of item2.cursamientos">
                                {{item3.grupo}} <br>
                            </tr>
                            </td>

                            <td style="width: 250px; ">
                                <tr style="text-align: center;" *ngFor="let item3 of item2.cursamientos">
                                    <p>{{item3.periodo_escolar}}</p> <br>
                                </tr>
                            </td>

                            <td style="width: 30px; align-content: center;">
                                <tr *ngFor="let item3 of item2.cursamientos">
                                    <ng-container *ngIf="item3.promedio_alumno_materia === null">
                                        <span>
                                            <b>--</b>
                                        </span>
                                    </ng-container>


                                    <ng-container *ngIf="item3.promedio_alumno_materia !== null">
                                        <span>
                                            <b>{{item3.promedio_alumno_materia.promedio}}</b>
                                        </span>
                                    </ng-container>
                                </tr>
                            </td>

                            <td style="width: 30px; text-align: center ;">
                                <tr *ngFor="let item3 of item2.cursamientos">
                                    <ng-container *ngIf="item3.promedio_alumno_materia === null">
                                        <span>
                                            <i class="fa fa-close" style="color:crimson;"></i>
                                        </span>
                                    </ng-container>

                                    <ng-container *ngIf="item3.promedio_alumno_materia !== null">
                                        <span *ngIf="item3.promedio_alumno_materia.aprobado !== 1">
                                            <i class="fa fa-close" style="color:crimson;"></i>
                                        </span>
                                        <span *ngIf="item3.promedio_alumno_materia.aprobado === 1">
                                            <i class="fa fa-check" style="color:rgb(26, 153, 0);"></i>
                                        </span>
                                    </ng-container>
                                </tr>
                            </td>

                            <td style="width: 150px;  text-align: center ;">
                                <tr *ngFor="let item3 of item2.cursamientos">
                                    <ng-container *ngIf="item3.promedio_alumno_materia === null">
                                        <span>
                                            <b>--</b>
                                        </span>
                                    </ng-container>

                                    <ng-container *ngIf="item3.promedio_alumno_materia !== null">
                                        <span>
                                            {{item3.promedio_alumno_materia.opcion_nombre}}
                                            {{item3.promedio_alumno_materia.opcion_tipo}}
                                        </span>
                                    </ng-container>
                                </tr>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

               
            </div> -->
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="ctrl.cancelarModal('reporteFinanciero');">Cerrar</a>
            <!-- <a class="button is-link" (click)="imprimirKardexdos();"> <span class="icon"> <i
                        class="fa fa-print"></i></span> <span>Kardex</span> </a>
            <a class="button is-warning" (click)="imprimirHistorial();"> <span class="icon"> <i
                        class="fa fa-print"></i></span> <span>Historial Académico</span> </a> -->
        </footer>
    </div>
</div>

<!-- <div class="modal" id="confirmarEliminarMov" style="z-index: 45;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
                    <i class="fa fa-file"></i>
                </span> Eliminar Pago
            </p>
            <button type="button" class="delete" (click)="ctrl.cancelarModal('confirmarEliminarMov');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro eliminar este pago?</h1>
              
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" [ngClass]="{'is-loading': borrarCargando}" (click)="confirmacionEliminar(borrarmov)">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarEliminarMov');">Cancelar</a>
        </footer>
    </div>
</div> -->

<div class="modal" id="confirmarActualizacion" style="z-index: 45;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarActualizacion');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de actualizar la información personal este alumno?</h1>
                <!-- <p>Las operaciones financieras y académicas del periodo actual seran truncadas.</p> -->
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="guardarDatos('actualizar-datos-personales','confirmarActualizacion');"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarActualizacion');">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="confirmarEliminar3" style="z-index: 45;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarEliminar3');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro dar de baja a este alumno?</h1>
                <p>Las operaciones financieras y académicas del periodo actual seran truncadas.</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="guardarBaja('baja', 'confirmarEliminar3');"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarEliminar3');">Cancelar</a>
        </footer>
    </div>
</div>



<div class="modal" id="confirmarEliminar2" style="z-index: 999999999999;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> [ Alerta ]</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarEliminar2');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿ Esta seguro de eliminar el elemento ??????????</h1>
                <p>Ya no se podra recuperar la información</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success"
                (click)="borrar(borrarItem, borrarRuta); ctrl.cancelarModal('confirmarEliminar2');"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarEliminar2');">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="confirmarEliminar4" style="z-index: 45;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarEliminar4');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Está seguro que desea revertir el proceso de baja?</h1>
                <p>Al aceptar esta acción, las operaciones financieras y académicas serán restaurados.</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="guardarBaja('deshacer-baja', 'confirmarEliminar4');"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarEliminar4');">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="historialBaja" style="z-index: 45;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-list"></i> Bajas</p>
            <button class="delete" (click)="ctrl.cancelarModal('historialBaja');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <table class="table is-striped is-fullwidth" style="width:100% !important;">
                    <thead>
                        <tr>
                            <th><abbr>ID</abbr></th>
                            <th>TIPO DE BAJA</th>
                            <th>DESCRIPCION</th>
                            <th>GRUPO</th>
                            <th>FECHA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of personas_historial_bajas; let i = index;">
                            <td style="vertical-align: middle;">{{ i + 1 }}</td>
                            <td style="vertical-align: middle;"> {{val.tipos_bajas.nombre}} </td>
                            <td style="vertical-align: middle;">{{ val.observaciones ? val.observaciones : ''}}</td>
                            <td style="vertical-align: middle;">{{ val.inscripciones.grupos ?
                                val.inscripciones.grupos.clave +" "+ val.inscripciones.grupos.nivel +" "+
                                val.inscripciones.grupos.identificador : '' }}</td>
                            <td style="vertical-align: middle;">{{ val.created_at ? val.created_at : '' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button" (click)="ctrl.cancelarModal('historialBaja');">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="pausa">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-list"></i> Pausa</p>
            <button class="delete" (click)="ctrl.cancelarModal('pausa');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <p>Tenga en cuenta que la ultima reincripción a pausar debe estar completa.</p>

                <div class="c-checkbox is-info">
                    <input id="invalidar" class="styled" type="checkbox" value="1"
                        [(ngModel)]="invalidar_inicializacion">
                    <label for="invalidar">
                        <b> Invalidar periodo</b>
                    </label>
                </div>
                <div class="column is-12">
                    <div class="field">
                        <label class="label">Observación:</label>
                        <p class="control has-icons-left has-icons-right">
                            <textarea class="textarea is-fullwidth" rows="5" placeholder="Observación"
                                [(ngModel)]="observaciones"></textarea>
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button type="button" class="button is-success" (click)="ctrl.abrirModal('confirmarEliminar5')">
                <i class="icon-diskette "></i>
                <span>&nbsp;Guardar</span>
            </button>
            <a class="button" (click)="ctrl.cancelarModal('pausa');">Cancelar</a>
        </footer>
    </div>
</div>


<div class="modal" id="confirmarEliminar5" style="z-index: 45;">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarEliminar5');"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de realizar pausa académica al alumno?</h1>
                <!-- <p>Las operaciones financieras y académicas del periodo actual seran truncadas.</p> -->
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success"
                (click)="guardarPausa(observaciones,invalidar_inicializacion,'pausa', 'confirmarEliminar5');"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarEliminar5');">Cancelar</a>
        </footer>
    </div>
</div>